import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import store from './store'

const AppProviders = ({ children }) => (
  <Provider store={store}>
    <BrowserRouter>{children}</BrowserRouter>
  </Provider>
)

export default AppProviders
